import { Button } from "@/design-system/components/ui";
import { Input } from "@/design-system/components/ui";
import { Select } from "@/components/ui/Select";
import { useMetricsFilter } from "./MetricsFilterContext";
import type { DealPipelineStageMetric } from "@/api/dealFlow/metrics";

// Top filter bar for the metrics dashboard. URL-syncs
// via the surrounding MetricsFilterProvider; "Clear" wipes every key.

const STAGES: DealPipelineStageMetric[] = [
  "Intake",
  "PreApproval",
  "Underwriting",
  "Closing",
  "Closed",
  "Declined",
  "Withdrawn",
];

export function MetricsFilterBar() {
  const { filter, patch, reset } = useMetricsFilter();
  return (
    <div
      className="flex flex-wrap items-end gap-space-3 rounded border border-border-light bg-white-pure p-space-3"
      data-testid="metrics-filter-bar"
    >
      <Field label="From">
        <Input
          type="date"
          value={filter.from ?? ""}
          onChange={(e) => patch({ from: e.target.value || undefined })}
        />
      </Field>
      <Field label="To">
        <Input
          type="date"
          value={filter.to ?? ""}
          onChange={(e) => patch({ to: e.target.value || undefined })}
        />
      </Field>
      <Field label="Stage">
        <Select
          value={filter.stage ?? ""}
          onChange={(e) =>
            patch({ stage: (e.target.value || undefined) as DealPipelineStageMetric | undefined })
          }
        >
          <option value="">All</option>
          {STAGES.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </Select>
      </Field>
      <Field label="Broker ID">
        <Input
          type="text"
          placeholder="GUID"
          value={filter.broker ?? ""}
          onChange={(e) => patch({ broker: e.target.value || undefined })}
        />
      </Field>
      <Field label="Analyst ID">
        <Input
          type="text"
          placeholder="user id"
          value={filter.analyst ?? ""}
          onChange={(e) => patch({ analyst: e.target.value || undefined })}
        />
      </Field>
      <Button variant="secondary" onClick={() => reset()}>
        Clear filters
      </Button>
    </div>
  );
}

function Field({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <label className="flex min-w-32 flex-col gap-1">
      <span className="text-label uppercase tracking-label text-gold-shadow">{label}</span>
      {children}
    </label>
  );
}
